// loading.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(NgxSpinnerService);

  const skipLoader = req.params.has('filter[search]');

  if (!skipLoader) {
    spinner.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoader) {
        spinner.hide();
      }
    })
  );
};
